import Vue from 'vue';
import { MLInstaller, MLCreate } from 'vue-multilanguage';
import EnLang from './config/lang/en.js';
import PtBrLang from './config/lang/pt-br.js';
import EsLang from './config/lang/es-es.js';
 
Vue.use(MLInstaller);
 
export default new MLCreate({
    initial: 'pt-br',
    save: process.env.NODE_ENV === 'production',
    languages: [
        EnLang,
        PtBrLang,
        EsLang
    ]
});